import { Transition } from '@mantine/core';
import { IconArrowBarRight } from '@tabler/icons-react';
import { useAppContainerContext } from '../AppContainerContext';
import { SidebarPillButton } from './SidebarPillButton';

type Props = {
  style?: React.CSSProperties;
};

export function ExitFullScreenPill({ style }: Props) {
  const { sidebarFullScreen, setSidebarFullScreen, preventSidebarCollapse } =
    useAppContainerContext();

  return (
    <Transition
      mounted={sidebarFullScreen && !preventSidebarCollapse}
      transition="fade"
      duration={350}
      timingFunction="ease-in"
    >
      {(styles: React.CSSProperties) => (
        <SidebarPillButton
          onClick={() => setSidebarFullScreen(false)}
          icon={<IconArrowBarRight size={16} color="var(--mantine-color-orange-6)" />}
          label="Show content"
          style={{ ...styles, ...style }}
        />
      )}
    </Transition>
  );
}
